import cn from 'clsx'

import { Button } from 'shared-components'

import s from './Categories.module.sass'

function Categories({ categories, selectedCategory, handleCategoryClick }: any) {
    if (categories?.length === 0 || !categories) {
        return null
    }

    return (
        <div className={s.Categories}>
            <div
                className={cn(s.Category, selectedCategory === '' && s.Active)}
                onClick={() => handleCategoryClick('')}
            >
                <Button
                    title="All"
                    handleClick={() => handleCategoryClick('')}
                    small
                    noArrow
                    inverted={selectedCategory === ''}
                />
            </div>
            {categories?.map((category: any, index: number) => {
                const { name, slug } = category

                return (
                    <div className={cn(s.Category, selectedCategory === slug && s.Active)} key={index}>
                        <Button
                            title={name}
                            handleClick={() => handleCategoryClick(slug)}
                            small
                            noArrow
                            inverted={selectedCategory === slug}
                        />
                    </div>
                )
            })}
        </div>
    )
}

export default Categories
